export const frontendURI = '/cat/position/';
export const backendURI = `/api${frontendURI}`;
